import { createFileRoute } from '@tanstack/react-router';
import { ServiceAreaPage } from '@/pages/service-area/ServiceAreaPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/settings/service-area')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({
			context,
			anyOf: ['companySettings.manageOrderSettings', 'chainHq.read'],
			redirectTo: '/settings/profile',
		}),
	component: ServiceAreaPage,
});
